import { createSlice } from '@reduxjs/toolkit';
import { arrayToMap } from 'utils/arrayToMap';
import { permissionsArrayToMap } from 'utils/permissionsArrayToMap';
import { loadAllCurrentUserPermissions } from '../thunks/loadAllCurrentUserPermissions.thunk';
import { loadUserSingleProjectPermissions } from '../thunks/loadUserSingleProjectPermissions';

export const projectPermissionsSlice = createSlice({
  name: 'projectPermissions',
  initialState: {
    userProjectPermissionsByProjectId: {},
    userAdminPermissions: {},
    userBusinessPermissions: {},
    loading: false,
    isPersonalPermissionsLoaded: false,
  },
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(loadUserSingleProjectPermissions.pending, (state) => ({
        ...state,
        loading: true,
      }))
      .addCase(loadUserSingleProjectPermissions.fulfilled, (state, action) => ({
        ...state,
        loading: false,
        userProjectPermissionsByProjectId: {
          ...state.userProjectPermissionsByProjectId,
          [action.payload.projectId]: action.payload.permissions,
        },
      }))
      .addCase(loadUserSingleProjectPermissions.rejected, (state, action) => ({
        ...state,
        loading: false,
        error: action.error,
      }))
      .addCase(loadAllCurrentUserPermissions.pending, (state) => {
        state.loading = true;
        state.isPersonalPermissionsLoaded = false;
      })
      .addCase(loadAllCurrentUserPermissions.fulfilled, (state, action) => {
        state.loading = false;
        state.userProjectPermissionsByProjectId = permissionsArrayToMap(
          action.payload.projectPermissions,
          'projectId'
        );
        state.userAdminPermissions = arrayToMap(
          action.payload.adminPermissions,
          'businessId'
        );
        state.userBusinessPermissions = permissionsArrayToMap(
          action.payload.businessPermissions,
          'businessId'
        );

        state.isPersonalPermissionsLoaded = true;
      })
      .addCase(loadAllCurrentUserPermissions.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error;
        state.isPersonalPermissionsLoaded = true;
      });
  },
});
